import { ClientsClient } from '@src/clients/services/ClientsClient';
import { TractorClient } from '@src/tractor/services/TractorClient';
import { TrailerClient } from '@src/trailer/service/TrailerClient';
import type { LoaderFunction } from 'react-router-dom';
import { defer } from 'react-router-dom';

type Loader = { loader: LoaderFunction; path: string };

export const Loaders: Record<string, Loader> = {
  client: {
    path: 'client',
    loader: async ({ params }) => {
      if (!params.clientId) return;
      return defer({
        client: ClientsClient.get(params.clientId),
      });
    },
  },
  clients: {
    path: 'clients',
    loader: async () => {
      return defer({
        clients: ClientsClient.list(),
      });
    },
  },
  tractor: {
    path: 'values',
    loader: async ({ params }) => {
      if (!params.clientId || !params.tractorId) return;
      const client = ClientsClient.get(params.clientId);
      const tractor = TractorClient.get(params.clientId, params.tractorId);
      return defer({
        values: Promise.all([client, tractor]),
      });
    },
  },
  trailer: {
    path: 'values',
    loader: async ({ params }) => {
      if (!params.clientId || !params.trailerId) return;
      const client = ClientsClient.get(params.clientId);
      const trailer = TrailerClient.get(params.clientId, params.trailerId);
      return defer({
        values: Promise.all([client, trailer]),
      });
    },
  },
};
